import { Reset_password } from "utils/constants";
import { getStytchTemplateCountry } from "utils/getStytchTemplateCountry";

export const useResetPasswordTemplate = () => {
  let index: string = getStytchTemplateCountry();
  const countryTemplate = Reset_password[index];
  return countryTemplate;
};
